import { render, staticRenderFns } from "./EstatePlanningSurveyHealthStatus.vue?vue&type=template&id=331a7483"
import script from "./EstatePlanningSurveyHealthStatus.vue?vue&type=script&lang=js"
export * from "./EstatePlanningSurveyHealthStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports